import React, { useEffect, useState } from 'react';
const API_GET = "https://v6d18bgl57.execute-api.us-west-1.amazonaws.com/prod/admin-users";
const API_POST = "https://v6d18bgl57.execute-api.us-west-1.amazonaws.com/prod/admin-update-plan";
const PLAN_OPTIONS = ["trial", "essentials", "premier"];

const PlanControls = ({ user }) => {
  const [users, setUsers] = useState([]);
  const [pendingChanges, setPendingChanges] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  
  useEffect(() => {
    const token = user?.signInUserSession?.idToken?.jwtToken;
    if (!token) {
      console.error("No JWT token available");
      return;
    }
    
    fetch(API_GET, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => setUsers(data.users || []))
      .catch(err => console.error("Failed to fetch users:", err));
  }, [user]);
  
  const handlePlanChange = (sub, selectedPlan) => {
    setPendingChanges(prev => ({ ...prev, [sub]: { selectedPlan, confirmed: false } }));
  };
  
  const saveChange = (sub) => {
    setPendingChanges(prev => ({
      ...prev,
      [sub]: { ...prev[sub], confirmed: true }
    }));
  };
  
  const commitChange = async (sub) => {
    const token = user?.signInUserSession?.idToken?.jwtToken;
    if (!token) {
      setStatusMessage("❌ No authentication token available");
      return;
    }
    
    const targetUser = users.find(u => u.sub === sub);
    const newPlan = pendingChanges[sub]?.selectedPlan;
    const adminEmail = user.attributes?.email || user.username || "jerdos@wedarchive.com";
    
    if (!PLAN_OPTIONS.includes(newPlan)) return;
    
    setStatusMessage("Updating...");
    try {
      const res = await fetch(API_POST, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ targetSub: sub, newPlan, adminEmail })
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const result = await res.json();
      
      setStatusMessage(`✅ Plan updated for ${targetUser.email}`);
      setUsers(users.map(u => u.sub === sub ? { ...u, plan: newPlan } : u));
      setPendingChanges(prev => {
        const { [sub]: _, ...rest } = prev;
        return rest;
      });
      setTimeout(() => setStatusMessage(""), 3000);
    } catch (err) {
      console.error("Update failed:", err);
      setStatusMessage(`❌ Failed to update plan: ${err.message}`);
    }
  };
  
  const cancelChange = (sub) => {
    setPendingChanges(prev => {
      const { [sub]: _, ...rest } = prev;
      return rest;
    });
  };

  return (
    <div className="container-fluid">
      <h3>Plan Controls</h3>
      {statusMessage && (
        <div className={`alert ${statusMessage.includes('✅') ? 'alert-success' : 'alert-danger'}`}>
          {statusMessage}
        </div>
      )}
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Email</th>
              <th>Current Plan</th>
              <th>New Plan</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => {
              const pending = pendingChanges[u.sub];
              return (
                <tr key={u.sub}>
                  <td>{u.email}</td>
                  <td>
                    <span className={`badge ${
                      u.plan === 'premier' ? 'bg-premier' : 
                      u.plan === 'essentials' ? 'bg-primary' : 'bg-secondary'
                    }`}>
                      {u.plan || 'trial'}
                    </span>
                  </td>
                  <td>
                    <select 
                      className="form-select form-select-sm"
                      value={pending?.selectedPlan || u.plan || 'trial'}
                      onChange={(e) => handlePlanChange(u.sub, e.target.value)}
                    >
                      {PLAN_OPTIONS.map(plan => (
                        <option key={plan} value={plan}>{plan}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    {pending && !pending.confirmed && (
                      <>
                        <button 
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => saveChange(u.sub)}
                        >
                          Save
                        </button>
                        <button 
                          className="btn btn-sm btn-secondary"
                          onClick={() => cancelChange(u.sub)}
                        >
                          Cancel
                        </button>
                      </>
                    )}
                    {pending?.confirmed && (
                      <>
                        <button 
                          className="btn btn-sm btn-danger me-2"
                          onClick={() => commitChange(u.sub)}
                        >
                          Confirm Change
                        </button>
                        <button 
                          className="btn btn-sm btn-secondary"
                          onClick={() => cancelChange(u.sub)}
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlanControls;
